// extracted by mini-css-extract-plugin
module.exports = {"tablePreview":"purchasePreview_tablePreview__1A9uz","tableHeader":"purchasePreview_tableHeader__3WdSF"};